import { dateUtil } from "@sdeapps/react-core";

export const nbsp = "\u00A0"; // non-breakable space

export const phoneAcceptedFormatsHelperText = `Les formats acceptés sont XX${nbsp}XX${nbsp}XX${nbsp}XX${nbsp}XX, XX.XX.XX.XX.XX, +XX${nbsp}X${nbsp}XX${nbsp}XX${nbsp}XX${nbsp}XX`;
export const invalidPhoneHelperText = `Numéro de téléphone invalide : ${phoneAcceptedFormatsHelperText}`;
export const phoneRegex = /^((\+\d{2}[./\s]?(\d{1,2}[./\s]?))|(\d{1,2}[./\s]?))(\d{2}[./\s]?){4}$/;
export const phoneRules = {
  pattern: {
    value: phoneRegex,
    message: invalidPhoneHelperText,
  },
};

export const eMailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const emailRules = {
  pattern: {
    value: eMailRegex,
    message: "Adresse e-mail invalide",
  },
};

export const validDateRules = {
  validate: (value: Date | null | undefined) =>
    dateUtil.isValid(value) || "Veuillez renseigner une date valide",
};
